"use client";
import { jsx as r } from "react/jsx-runtime";
import { memo as i } from "react";
import { Button as n } from "./Button.js";
import { s } from "../../Button.module-C3Ja-wjg.js";
const e = i(
  ({ icon: o, onClick: t, ...m }) => /* @__PURE__ */ r(
    n,
    {
      iconLeft: o,
      size: "tiny",
      color: "overlay",
      className: s.icon_info,
      onClick: t,
      ...m
    }
  )
);
e.displayName = "ButtonInfo";
export {
  e as ButtonInfo
};
